import FJTextBasedEditingLeft from './left/FJTextBasedEditingLeft.jsx';
import { useEffect } from 'react';
import FJCodecStore from '../../store/FJCodecStore.js';

import FJTextBasedEditingRightContainer from './right/container/FJTextBasedEditingRightContainer';

const FJTextBasedEditing = () => {
    useEffect(() => {
        FJCodecStore.init();
    }, []);

    return (
        <>
            <FJTextBasedEditingLeft />
            <FJTextBasedEditingRightContainer />
        </>
    );
};

export default FJTextBasedEditing;
